import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '../../../../../../graphql/hooks';
import { UpdateSectionProps, UpdateSectionMutationResult } from './types';
import { UPDATE_SECTION_NAME, DELETE_SECTION } from '../../../../graphql';
import { OnSubmitType } from '../types';
import SectionFormView from '../SectionFormView';

const UpdateSectionForm = ({ id, name, count }: UpdateSectionProps) => {
    const [update, { loading }] = useMutation<UpdateSectionMutationResult>(
        UPDATE_SECTION_NAME,
    );
    const [remove] = useMutation<boolean>(DELETE_SECTION);
    const onClick = async () => {
        try {
            await remove({
                variables: { id },
                update: cache => {
                    cache.modify({
                        fields: {
                            sections(sectionRefs: any[], { readField }) {
                                return sectionRefs.filter(
                                    sectionRef => id !== readField('id', sectionRef)
                                );
                            },
                        },
                    });
                }
            });
        } catch (error) {
            // nothing we can do
        }
    };

    const { t } = useTranslation();

    const onSubmit: OnSubmitType = async values => {
        const { sectionName } = values;
        const variables = { id, name: sectionName };
        await update({ variables });
    };
    const initialValues = {
        sectionName: name,
    };
    return (
        <SectionFormView
            count={count}
            onSubmit={onSubmit}
            isLoading={loading}
            initialValues={initialValues}
            submitText={t('Update')}
            onDelete={onClick}
        />
    );
};

export default UpdateSectionForm;
